"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComponentContentById = void 0;
const getComponentContentById = (components, id) => {
    const component = components?.find(({ componentId }) => componentId === id);
    if (component)
        return component.content;
};
exports.getComponentContentById = getComponentContentById;
